<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_5305_76492)">
			<path d="M17.25 13.5V14.9921C17.25 15.4063 16.9142 15.7421 16.5 15.7421C16.4974 15.7421 16.4948 15.7421 16.4922 15.7421L8.24216 15.6558C7.83103 15.6515 7.5 15.317 7.5 14.9058V13.5" stroke="#00ADEF" stroke-width="1" stroke-linecap="round"/>
			<path d="M12.375 13.4994C12.2328 13.4994 12.1098 13.4464 12.0059 13.3404L9.90586 11.1975C9.80195 11.0915 9.75 10.966 9.75 10.8209C9.75 10.6758 9.80195 10.5502 9.90586 10.4442C10.0098 10.3382 10.1328 10.2852 10.275 10.2852H11.325H13.425H14.475C14.6172 10.2852 14.7402 10.3382 14.8441 10.4442C14.948 10.5502 15 10.6758 15 10.8209C15 10.966 14.948 11.0915 14.8441 11.1975L12.7441 13.3404C12.6402 13.4464 12.5172 13.4994 12.375 13.4994Z" fill="#00ADEF"/>
			<path d="M13.5 11.25L13.5 6.75C13.5 6.33579 13.1642 6 12.75 6H12C11.5858 6 11.25 6.33579 11.25 6.75V11.25C11.25 11.6642 11.5858 12 12 12H12.75C13.1642 12 13.5 11.6642 13.5 11.25Z" fill="#00ADEF"/>
		</g>
	</svg>
</template>

<script>
export default {};
</script>
